import React, { Component } from "react";
import { toast } from "react-toastify";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";
import { Button, Modal, Form, Badge, Spinner, Pagination } from "react-bootstrap";
import { getTransactions, getMyTransactions, getTransactionsCount } from "../services/transactionService";
import { formatNumber } from "../services/util";
import PageLoading from "./common/pageLoading";
import {
  isCustomer,
  isAdmin,
  isSuperAdmin,
  isAccounts,
} from "../services/authService";
import { changeStatus } from "../services/transactionService";

class Transactions extends Component {
  state = {
    transactions: [],
    showConfirmModal: false,
    transationToUpdate: {},
    loading: "",
    searchQuery: "",
    processing: false,
    pageSize: 20,
    currentPage: 1,
    totalTransactions: 0,
  };

  constructor() {
    super();
    this.state.loading = true;
  }

  async componentDidMount() {
    const { currentPage, pageSize, searchQuery } = this.state;
    await this.populateTransactions(currentPage, pageSize, searchQuery);
  }

  async populateTransactions(currentPage, pageSize, searchQuery) {
    try {
      let transactions = [];
      let totalTransactions = 0;
      if (isCustomer()) {
        const { data } = await getMyTransactions();
        transactions = data;
      } else {
        const { data } = await getTransactions(currentPage, pageSize, searchQuery);
        const { data: count } = await getTransactionsCount(searchQuery);
        transactions = data;
        totalTransactions = count;
      }
      this.setState({ transactions, totalTransactions });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  showConfirmModal = (transationToUpdate) => {
    this.setState({ showConfirmModal: true, transationToUpdate });
  };

  handleClose = () => {
    this.setState({ showConfirmModal: false });
  };

  handleSearch = async (e) => {
    this.setState({ loading: true });
    const { currentPage, pageSize } = this.state;
    const value = e.currentTarget.value;
    this.setState({ searchQuery: value, currentPage: 1 });
    await this.populateTransactions(currentPage, pageSize, value);
  };

  handlePageChange = async (direction) => {
    this.setState({ loading: true });
    const { currentPage, pageSize, searchQuery } = this.state;
    const newPage = direction === "next" ? currentPage + 1 : currentPage - 1;

    await this.populateTransactions(newPage, pageSize, searchQuery);
    this.setState({ currentPage: newPage });
  };

  handleUpdateStatus = async (transaction, newStatus) => {
    this.setState({ processing: true });
    const { transactions: originalTransactions } = this.state;
    const transactions = [...originalTransactions];

    const index = transactions.indexOf(transaction);
    transaction.status = newStatus;
    transactions[index] = transaction;

    toast("Updating Status. Please Wait...");
    this.setState({ transactions, showConfirmModal: false });

    try {
      await changeStatus(transaction._id, newStatus);
      toast.success("Status Updated");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) toast.error(ex.response.data);
      this.setState({ transactions: originalTransactions });
    }
    this.setState({ processing: false });
  };

  render() {
    const {
      transactions,
      totalTransactions,
      showConfirmModal,
      transationToUpdate,
      searchQuery,
      loading,
      processing,
      currentPage,
      pageSize,
    } = this.state;

    const pagesCount = Math.ceil(totalTransactions / pageSize);

    return (
      <React.Fragment>
        {isAdmin() && (
          <Form>
            <Form.Group controlId="searchQuery">
              <Form.Control
                type="text"
                name="searchQuery"
                value={searchQuery}
                autoFocus
                autoComplete="off"
                onChange={this.handleSearch}
                placeholder="Search Transaction By Customer Name..."
              />
            </Form.Group>
          </Form>
        )}
        <Paper elevation={3}>
          <div className="card">
            <div className="card-header main-color-bg">
              <h5>Transactions</h5>
            </div>
            <div className="card-body">
              <span className="card-text">
                {loading && <PageLoading loading={loading} />}
                {!loading && transactions.length === 0 && (
                  <span>No Transactions to Display</span>
                )}
                {!loading && transactions.length > 0 && (
                  <TableContainer component={Paper}>
                    <Table aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>Date</StyledTableCell>
                          <StyledTableCell>Amount</StyledTableCell>
                          <StyledTableCell>Method</StyledTableCell>
                          <StyledTableCell>Status</StyledTableCell>
                          <StyledTableCell>Initiator</StyledTableCell>
                          {isAdmin() && (
                            <StyledTableCell>Customer</StyledTableCell>
                          )}
                          {isAdmin() && <StyledTableCell></StyledTableCell>}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {transactions.map((transaction) => (
                          <StyledTableRow key={transaction._id}>
                            <StyledTableCell component="th" scope="row">
                              {transaction.formattedDate}
                            </StyledTableCell>
                            {transaction.amount >= 0 && (
                              <StyledTableCell
                                className={`${transaction.type === "Credit" ? "text-success" : "text-danger"}`}
                              >
                                {`${transaction.type === "Credit" ? "+" : "-"}`}
                                &#8358;
                                {formatNumber(transaction.amount.toFixed(2))}
                              </StyledTableCell>
                            )}
                            <StyledTableCell>
                              {transaction.method}
                            </StyledTableCell>
                            <StyledTableCell>
                              <Badge
                                variant={`${transaction.status === "Verified" ? "success" : "danger"}`}
                              >
                                {transaction.status}
                              </Badge>
                            </StyledTableCell>
                            <StyledTableCell>
                              {transaction.initiator}
                            </StyledTableCell>
                            {isAdmin() && (
                              <StyledTableCell>
                                {transaction.user}
                              </StyledTableCell>
                            )}
                            {isAdmin() &&
                              transaction.method !== "Online" &&
                              transaction.status === "Pending" && (
                                <StyledTableCell>
                                  {(isAccounts() || isSuperAdmin()) && (
                                    <Button
                                      onClick={() =>
                                        this.showConfirmModal(transaction)
                                      }
                                      variant="warning"
                                    >
                                      Update Status
                                    </Button>
                                  )}
                                </StyledTableCell>
                              )}
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}

                {!loading && pagesCount > 0 && (
                  <Pagination className="mt-5">
                    {pagesCount > 1 && (
                      <React.Fragment>
                        {currentPage !== 1 && (
                          <Pagination.Item
                            onClick={() => this.handlePageChange("prev")}
                          >
                            Previous
                          </Pagination.Item>
                        )}
                        <Pagination.Item>
                          Page {currentPage} of {pagesCount}
                        </Pagination.Item>
                        {currentPage !== pagesCount && (
                          <Pagination.Item
                            onClick={() => this.handlePageChange("next")}
                          >
                            Next
                          </Pagination.Item>
                        )}
                      </React.Fragment>
                    )}
                  </Pagination>
                )}
              </span>
            </div>
          </div>

          <Modal
            show={showConfirmModal}
            size="md"
            centered
            onHide={this.handleClose}
          >
            <Modal.Header closeButton className="bg-warning text-white">
              <Modal.Title>Update Transaction Status</Modal.Title>
            </Modal.Header>
            {transationToUpdate.amount && (
              <Modal.Body>
                Are you sure you want to update the status of the transaction of
                &#8358;
                {formatNumber(transationToUpdate.amount.toFixed(2))} for{" "}
                {transationToUpdate.user}?
                <br />
                <small className="text-danger">
                  Make sure that the payment has been verified
                </small>
              </Modal.Body>
            )}

            <Modal.Footer>
              <Button onClick={this.handleClose} variant="secondary">
                Cancel
              </Button>
              <Button
                onClick={() =>
                  this.handleUpdateStatus(transationToUpdate, "Disapproved")
                }
                type="submit"
                variant="danger"
                disabled={processing}
              >
                {processing && (
                  <Spinner
                    as="span"
                    className="mr-2"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
                No, Disapprove
              </Button>
              <Button
                onClick={() =>
                  this.handleUpdateStatus(transationToUpdate, "Verified")
                }
                type="submit"
                disabled={processing}
                variant="primary"
              >
                {processing && (
                  <Spinner
                    as="span"
                    className="mr-2"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
                Yes, Approve
              </Button>
            </Modal.Footer>
          </Modal>
        </Paper>
      </React.Fragment>
    );
  }
}

export default Transactions;
